import React from 'react'
import 'animate.css';

function NoTicketsList() {
return (
    <div className="pt-20 flex items-center justify-center">
        <h1 class="animate__animated animate__lightSpeedInLeft text-black text-[24px]">Woah, No tickets</h1>
    </div>
)
}

export default NoTicketsList